// extracted by mini-css-extract-plugin
module.exports = {"EducationOrgsTable":"_2HNGgnWx","educationOrgContent":"_2vHHeo3y","educationOrgHeader":"_3jwnaRPz","educationOrgBottom":"bN0i66bx","candidateHeaderLeft":"_1sca0Q1s","unverifiedStatus":"_1wb2_4OU","iconDanger":"_2XI0h0pO","verifiedStatus":"ROHn239X","actionsContent":"_1syVH8-j","nameHeader":"_8ryyFeIN","statusHeader":"HrZVTyGX","candActionHeader":"_3Qup9JLY"};
    if(module.hot) {
      // 1746735882763
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  